var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('validation-provider',{attrs:{"rules":_vm.validations},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('v-text-field',{attrs:{"value":_vm.value,"label":_vm.field.label,"disabled":_vm.readonly,"outlined":_vm.outlined,"error-messages":errors,"color":"#005c7b"},on:{"change":_vm.onChange}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }